module.exports = __webpack_public_path__ + "static/media/05_sognolucido.b810fc61.jpg";